import { storage, PRIVATE_BUCKET, id } from "@/appwrite";
import { HookResponse } from "@models/Models";

const useImage = () => {

    const uploadImage = async (file: File) => {
        try {
            const response = await storage.createFile({
                bucketId: PRIVATE_BUCKET,
                fileId: id.unique(),
                file
            });

            if(!response.$id) {
                return {
                    success: false,
                    message: 'Failed to upload image',
                    data: null
                }
            };

            return {
                success: true,
                message: 'Image uploaded successfully',
                data: response.$id
            };

        }catch (error: any) {
            console.error('Error uploading image:', error);
            return {
                success: false,
                message: error.message,
                data: null
            }
        };
    };

    const getPublicURL = (fileID: string): HookResponse => {
        try {
            if(!fileID || fileID === "" || fileID.length < 10) {
                console.log("Image id was not valid: ", fileID);
                return {
                    success: false,
                    message: "Image id was not valid",
                    data: null
                }
            }

            const response = storage.getFilePreview({
                bucketId: PRIVATE_BUCKET,
                fileId: fileID,
                width: 350,
                height: 200,
                quality: 50
            });

            if(!response) {
                return {
                    success: false,
                    message: 'Failed to upload image',
                    data: null
                }
            };

            return {
                success: true,
                message: 'Image uploaded successfully',
                data: response
            };

        }catch (error: any) {
            console.error('Error getting image:', error);
            return {
                success: false,
                message: error.message,
                data: null
            }
        };
    };

    const getPublicURLOriginalQ = async (fileID: string): Promise<HookResponse> => {
        try {
            const response = await storage.getFilePreview({
                bucketId: PRIVATE_BUCKET,
                fileId: fileID
            });

            if(!response) {
                return {
                    success: false,
                    message: 'Failed to upload image',
                    data: null
                }
            };

            return {
                success: true,
                message: 'Image uploaded successfully',
                data: response
            };

        }catch (error: any) {
            console.error('Error getting image:', error);
            return {
                success: false,
                message: error.message,
                data: null
            }
        };
    };

    return {
        uploadImage,
        getPublicURL,
        getPublicURLOriginalQ
    }
};

export default useImage;